// core
import React, { useState } from "react";

// components
import Icon from "../Icon/Icon";

// types
import { Severity } from "../../interfaces/enums/Severity";
import { IconSetIds } from "../Icon/IconMap";

// styles
import cx from "classnames";
import styles from "./Alert.module.scss";
import Button from "../Forms/Button/Button";

interface IAlertPropsShared {
    severity: Severity;
    className?: string;
    isFitContent?: boolean;
    isHighlighted?: boolean;
    isDismissible?: boolean;
}

interface IAlertPropsBase extends IAlertPropsShared {
    callToAction?: undefined;
    onClickCallToAction?: undefined;
}
interface IAlertCallToAction extends IAlertPropsShared {
    callToAction: React.ReactNode;
    onClickCallToAction: () => Promise<void> | void;
}

type IAlertProps = IAlertPropsBase | IAlertCallToAction;

const Alert: React.FC<IAlertProps> = (props) => {
    const { severity, className, isFitContent, isHighlighted, isDismissible } = props;

    const [isClosed, setIsClosed] = useState(false);

    let alertIcon: IconSetIds = undefined;

    switch (severity) {
        case Severity.Info:
            alertIcon = "AlertInfo";
            break;
        case Severity.Success:
            alertIcon = "GreenTick";
            break;
        case Severity.Error:
        default:
            alertIcon = "AlertError";
            break;
    }

    if (isClosed) {
        return null;
    }

    return (
        <div
            className={cx([styles["layout-alert"]], [styles["alert"]], {
                [className]: !!className,
                ["layout-fit-content"]: isFitContent,
                [styles["alert-background-highlighted"]]: isHighlighted,
                [styles["alert--error"]]: severity === Severity.Error
            })}>
            {isDismissible && (
                <button
                    onClick={() => setIsClosed(true)}
                    className={styles["button-close"]}>
                    <Icon id={"GreyCross"} size="ml" />
                </button>
            )}
            {alertIcon && <Icon id={alertIcon} className={styles["alert-icon"]} />}
            <div className="layout-flex-column">
                <div className="space-ml">{props.children}</div>
                {props.callToAction && (
                    <Button
                        component="button"
                        variant="default"
                        size="s"
                        width="content"
                        className="space-pre-auto"
                        onClick={props.onClickCallToAction}>
                        {props.callToAction}
                    </Button>
                )}
            </div>
        </div>
    );
};

export default Alert;
